export const CODE_SYNC_FLAG_NAMES = {
  SAMPLE_CODE_LIBRARY: 'ff-sample-code-library',
};

export const CODE_SYNC_DYNAMIC_CONFIG_NAMES = {
  DEVLINK_LIMITS: 'dc-csy-674-devlink-limits',
  CODE_COMPONENTS_SANDBOX_TTL: 'dc-csy-ext-604-code-components-sandbox-ttl',
  FUNCTIONS_PREVIEW_SANDBOX: 'dc-csy-ext-1248-functions-preview-sandbox',
} as const;
